import { MD5, SHA512 } from "crypto-js";

export const validatePassword = (pass: string) => {
  const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%*()_+^&}{:;?.])([0-9a-zA-Z!@#$%*()_+^&}{:;?.]{8,})$/;

  if (pass === null || pass === undefined || pass === "") {
    return "É necessário informar a nova senha";
  }

  if (!pass.match(regex)) {
    return "A senha possui um formato inválido";
  }

  return false;
};

export const checkNewPassword = (type: string, pass: string) => {
    switch (type) {
        case "blank":
            return pass.match(/^(\S+$)/) ? "default" : "error";
        case "number":
            return pass.match(/^(?=.*[0-9])/) ? "default" : "error";
        case "upper":
            return pass.match(/^(?=.*[A-Z])/) ? "default" : "error";
        case "lower":
            return pass.match(/^(?=.*[a-z])/) ? "default" : "error";
        case "special":
            return pass.match(/^(?=.*[!@#$%*()_+^&}{:;?.])/) ? "default" : "error";
        case "min":
            return pass.match(/^(.{8,})$/) ? "default" : "error";
        default:
            return "default";
    }
}

export const encryptPassword = async (value: string) => {
    return SHA512(MD5(value).toString().toUpperCase()).toString().toUpperCase();
}


// WEBPACK FOOTER //
// ./src/services/PasswordService.tsx